<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="统计周期权限"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <div class="content-box">
            <el-form ref="form" label-width="20px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item label="" prop="period">
                    <el-checkbox v-model="item.checked" v-for="item in periodOptions">{{item.display_name}}</el-checkbox>
                </el-form-item>
                <el-form-item v-if="checkedLatestDays&&!isRemove" label="自定义最近天数限制：" prop="data_days" label-width="150px">
                    <el-input v-model="formItem.data_days" size="mini" :disabled="isView" style="width: 150px;" placeholder="请输入天数"></el-input>
                    <span class="text-color-gray font12px ml20">不包含今天，用户设置的自定义最近天数的输入值不可超过此处限制</span>
                </el-form-item>
                <el-form-item v-if="checkedStartDate&&!isRemove" label="自定义开始日期限制：" prop="start_date" label-width="150px">
                    <el-date-picker
                        :disabled="isView"
                        style="width: 150px;"
                        size="mini"
                        v-model="formItem.start_date"
                        :picker-options="startPickerOptions"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        type="date"
                        :clearable="false"
                        placeholder="请选择日期">
                    </el-date-picker>
                    <span class="text-color-gray font12px ml20">用户不可选择此处限制之前的日期（包含当天）</span>
                </el-form-item>
            </el-form>


        </div>
        <div slot="footer" class="dialog-footer tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div slot="footer" class="dialog-footer tac" v-else>
            <el-button type="default" @click="cancelSubmit" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import util from '@/libs/utils';

    export default {
        name: "StatisticalPeriodModal",
        props:{
            isView:{
                type: Boolean,
                default:false,
            },
            isRemove:{
                type: Boolean,
                default:false,
            },
            page:{
                type: Object,
                required: true
            },
            fields: {
                type: Array,
                required: true
            },
        },
        data(){
            let _this = this;
            const validPeriod = (rule, value, callback) =>{
                if(!_this.isRemove&&_this.periodOptions.length>0&&_this.periodOptions.every(item=>!item.checked)){
                    callback(new Error('请至少选择一个选项'));
                }else{
                    callback();
                }
            };
            const validDataDays = (rule, value, callback) =>{
                if(!_this.checkedLatestDays||_this.isRemove){
                    callback();
                }else{
                    if(!_this.formItem.data_days){
                        callback(new Error('请输入自定义最近天数限制'));
                    }else if(isNaN(_this.formItem.data_days)||+_this.formItem.data_days<=0||_this.formItem.data_days.includes('.')){
                        callback(new Error('请输入大于0的整数'));
                    }else if(_this.formItem.data_days<1||_this.formItem.data_days>366){
                        callback(new Error('自定义最近天数最小为1，最大366'));
                    }else{
                        callback();
                    }
                }
            };

            const validStartDate = (rule, value, callback) =>{
                if(!_this.checkedStartDate||_this.isRemove){
                    callback();
                }else{
                    if(!_this.formItem.start_date){
                        callback(new Error('请选择自定义开始日期限制'));
                    }else{
                        callback();
                    }
                }
            };


            return {
                dialogVisible:false,
                formItem:{
                    period:[],
                    data_days:'',
                    start_date:'',
                },
                startPickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() > Date.now()-1000*60*60*24;
                    },
                },
                rules:{
                    period:[
                        { validator: validPeriod, trigger: 'blur' },
                    ],
                    data_days:[
                        { validator: validDataDays, trigger: 'blur' },
                    ],
                    start_date:[
                        { validator: validStartDate, trigger: 'blur' },
                    ],
                },
                periodOptions:[],
            }
        },
        computed:{
            checkedLatestDays(){
                let actionItem = this.periodOptions.find(item=>item.name=='customize_the_latest_days');
                return actionItem&&actionItem.checked;
            },
            checkedStartDate(){
                let actionItem = this.periodOptions.find(item=>item.name=='customize_the_start_date');
                return actionItem&&actionItem.checked;
            },
        },
        watch: {
            fields: {
                handler(new_value) {
                    this.periodOptions = util.deepClone(new_value);
                    this.oldData = util.deepClone(this.periodOptions)
                },
                deep: true,
                immediate: true,
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
            },
            resetData(){
                console.log('resetData');
                this.periodOptions =  util.deepClone(this.oldData);
                this.formItem.data_days = '';
                this.formItem.start_date = '';
            },
            showModal(config={}){
                console.log('showModal',config)
                if(config.customize_the_latest_days){
                    this.formItem.data_days = config.customize_the_latest_days;
                }
                if(config.customize_the_start_date){
                    this.formItem.start_date = config.customize_the_start_date;
                }

                this.dialogVisible = true;
            },
            cancelSubmit(){
                this.dialogVisible = false;
                this.resetData();
            },
            handleSubmit() {
                this.$refs.form.validate((valid) => {
                    if(valid){
                        this.oldData = util.deepClone(this.periodOptions);
                        if(this.isRemove){
                            /* 批量删除 */
                            this.$emit('save',this.page,{
                                period:this.periodOptions.filter(item=>!!item.checked).map(item=>item.id),
                            });
                        }else{
                            this.$emit('save',this.page,{
                                data_days:this.checkedLatestDays?this.formItem.data_days:'',
                                start_date:this.checkedStartDate?this.formItem.start_date:'',
                                period:this.periodOptions.filter(item=>!!item.checked).map(item=>item.id),
                            });
                        }

                        this.handleClose();
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
        }
    }
</script>

<style scoped>

</style>
